// Single source of truth for the variables that can be inserted into an email
// template. Add/adjust entries here to expose more variables in the editor.
//
// In the editor the variable shows as its friendly `[label]` (e.g. "[Student
// Name]"); in the saved `body` it is stored as `{{key}}` (e.g. "{{studentName}}").
export const EMAIL_TEMPLATE_VARIABLES = [
  { key: "studentName", label: "Student Name", category: "Student" },
  { key: "studentEmail", label: "Student Email", category: "Student" },
  { key: "studentFirstName", label: "Student First Name", category: "Student" },
  { key: "studentLastName", label: "Student Last Name", category: "Student" },
  { key: "applicationId", label: "Application ID", category: "Application" },
  {
    key: "applicationStatus",
    label: "Application Status",
    category: "Application",
  },
  { key: "instituteName", label: "Institute Name", category: "Application" },
]

// Display token shown inside the editor, e.g. "[Student Name]".
export const toDisplayToken = v => `[${v.label}]`
// Storage token saved in the body / sent to the API, e.g. "{{studentName}}".
export const toStorageToken = v => `{{${v.key}}}`

// Convert the editor content ([Label]) into the stored form ({{key}}).
export const displayToStorage = html => {
  let out = html || ""
  EMAIL_TEMPLATE_VARIABLES.forEach(v => {
    out = out.split(toDisplayToken(v)).join(toStorageToken(v))
  })
  return out
}

// Convert stored content ({{key}}) back into the editor form ([Label]).
export const storageToDisplay = html => {
  let out = html || ""
  EMAIL_TEMPLATE_VARIABLES.forEach(v => {
    out = out.split(toStorageToken(v)).join(toDisplayToken(v))
  })
  return out
}

// The variable objects actually used across the given text(s), stored form.
export const collectUsedVariables = (...texts) => {
  const haystack = texts.filter(Boolean).join(" ")
  return EMAIL_TEMPLATE_VARIABLES.filter(v =>
    haystack.includes(toStorageToken(v)),
  )
}
